import { prStore, type File } from '../stores/pr';
import { Accordion } from './accordion';
import { Form } from './form';

type FileEditorAccordionProps = {
    file: File;
    openInitially: boolean;
    showRemove: boolean;
};

export const FileEditorAccordion = ({ file, openInitially, showRemove }: FileEditorAccordionProps) => (
    <Accordion
        header={
            <>
                {showRemove && (
                    <button
                        className="btn btn-sm btn-outline-secondary me-2"
                        title={
                            file.statusComparedToBase === 'added'
                                ? 'Remove this record from the PR'
                                : 'Remove the changes to this record from the PR'
                        }
                        onClick={(e) => {
                            e.stopPropagation();
                            const fileHasChanges = prStore.get.getChangedFiles().some((f) => f.id === file.id);
                            if (!fileHasChanges || confirm('This record has changes that will be lost. Are you sure?'))
                                prStore.set.discardFileChanges(file.id);
                        }}>
                        <i className="bi-trash" />
                    </button>
                )}
                <span>
                    {file.editorChanges.filename ||
                        file.head?.filename ||
                        (file.statusComparedToBase === 'added' ? 'New company' : '<company without slug>')}{' '}
                    ({file.statusComparedToBase})
                </span>
            </>
        }
        openInitially={openInitially}
        className="my-3"
        color={
            file.statusComparedToBase === 'modified'
                ? 'warning'
                : file.statusComparedToBase === 'unchanged'
                ? 'dark-subtle'
                : undefined
        }>
        <Form
            initialData={file.editorChanges.record || file.head?.record}
            filename={file.editorChanges.filename || file.head?.filename || ''}
            file={file}
            onChange={(formData) => {
                const filename = formData.record.slug ? `companies/${formData.record.slug}.json` : undefined;
                prStore.set.setForFile(file.id, {
                    editorChanges: {
                        filename: filename !== file.head?.filename ? filename : undefined,
                        record: formData.record,
                    },
                    validationErrors: formData.validationErrors,
                });
            }}
        />
    </Accordion>
);
